import BodyType from 'owa-service/lib/contract/BodyType';
import MessageComposeAdapter from '../../adapters/MessageComposeAdapter';
import { ApiMethodCallback } from '../ApiMethod';
import { createSuccessResult } from '../ApiMethodResponseCreator';
import { getAdapter } from '../../adapters/AdapterManager';

export default function getBodyTypeAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: null,
    callback: ApiMethodCallback
): void {
    const adapter = getAdapter(hostItemIndex) as MessageComposeAdapter;
    const bodyType: BodyType = adapter.getBodyType();
    const typeString: string = (bodyType && bodyType.toLowerCase()) || null;

    callback(createSuccessResult(typeString));
}
